import { render, staticRenderFns } from "./heads.vue?vue&type=template&id=20f2906d&"
import script from "./heads.vue?vue&type=script&lang=js&"
export * from "./heads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./heads.vue?vue&type=custom&index=0&blockType=link&rel=stylesheet&href=..%2Fassets%2Fcss%2Ficonfont.css"
if (typeof block0 === 'function') block0(component)

export default component.exports